<template>
  <div>
    <div
      v-if="
        typeof error_messages === 'object' &&
          Object.keys(error_messages).length > 0
      "
      class="alert alert-danger"
    >
      <ul>
        <template v-for="(error, i) in error_messages">
          <span v-bind:key="i">
            <li v-for="(message, ii) in error" v-bind:key="ii">
              {{ message }}
            </li>
          </span>
        </template>
      </ul>
    </div>
    <div class="tabs">
      <v-tabs
        v-model="tab"
        background-color="light primary"
        class="elevation-2"
        dark
      >
        <v-tab>{{ $t("OPERATOR") }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <vue-form-generator
                ref="form"
                :schema="operatorSchema"
                :model="operator"
                :options="formOptions"
              ></vue-form-generator>

              <v-btn
                @click="save()"
                class="btn btn-success btn-elevate kt-login__btn-primary text-white"
                >{{ $t("SAVE") }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css"; // optional full css additions

import {
  GET_OPERATOR,
  SAVE_OPERATOR,
  UPDATE_OPERATOR
} from "@/store/operators.module";

import { mapGetters, mapState } from "vuex";
// Vue.use(VueFormGenerator)
import _ from "lodash";

export default {
  name: "createUpdate",

  components: {
    "vue-form-generator": VueFormGenerator.component
  },
  computed: {
    ...mapGetters(["isLoadingOperators"]),
    ...mapState({
      errors: state => state.auth.errors
    }),
    isEdit: function() {
      if (typeof this.$route.params.id !== "undefined") {
        return true;
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      error_messages: [],
      model: "operators",
      tab: 0,
      operator: {
        name: null,
        email: null,
        password: null,
        role: null
      },
      operatorSchema: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: this.$t("NAME") + " (BG)",
            model: "firstName",
            required: true,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("NAME") + " (EN)",
            model: "firstName_en",
            required: true,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("LAST_NAME") + " (BG)",
            model: "lastName",
            required: true,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("LAST_NAME") + " (EN)",
            model: "lastName_en",
            required: true,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("SIGNATURE_CODE"),
            model: "sealCode",
            required: true,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("CODE"),
            model: "code",
            required: true,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("THE_FIELD_IS_REQUIRED") + " !!!"
            })
          },
          {
            type: "checkbox",
            label: this.$t("ACTIVE"),
            model: "active",
            required: true
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: false,
        validateAsync: true
      }
    };
  },
  mounted() {
    let vm = this;

    _.delay(function() {
      var current_page = vm.$t("ADD");
      if (typeof vm.$route.params.id !== "undefined") {
        current_page = vm.$t("MODIFY");
      }
      vm.$store.dispatch(SET_BREADCRUMB, [
        { title: this.$t("OPERATORS"), route: "/operators" },
        { title: current_page }
      ]);
    }, 300);
    if (typeof this.$route.params.id !== "undefined") {
      this.getData();
    }
  },
  methods: {
    async save() {
      let vm = this;

      vm.error_messages = [];

      let errors = await this.$refs.form.validate();

      if (errors.length) {
        return;
      }

      var action =
        typeof this.$route.params.id !== "undefined"
          ? UPDATE_OPERATOR
          : SAVE_OPERATOR;

      vm.$store
        .dispatch(action, { payload: vm.operator })
        .then(data => {
          vm.$notification["success"]({
            message: data.status,
            description: data.message
          });

          vm.$router.push({ name: "operatorsList" });
        })
        .catch(response => {
          vm.error_messages = response.data.errors;
          vm.$scrollTo("html", 420, {
            offset: -300
          });

          if (response.status === 404) {
            vm.$notification["success"]({
              message: response.status,
              description: response.message
            });
            vm.$router.push({ name: "operatorsList" });
          }
        });
    },
    getData: function() {
      let vm = this;
      this.error_messages = [];
      let id = this.$route.params.id;
      this.$store
        .dispatch(GET_OPERATOR, id)
        .then(data => {
          vm.$nextTick(function() {
            vm.operator = data.data;
          });
        })
        .catch(response => {
          vm.error_messages = response.data.errors;
          vm.$scrollTo("html", 420, {
            offset: -300
          });

          if (typeof response === "undefined" || response.status === 404) {
            vm.$notification["error"]({
              message: this.$t("ERROR") + " 404",
              description: this.$t("PAGE_NOT_FOUND")
            });
            vm.$router.push({ name: "operatorsList" });
          }
        });
    },
    handleValidation: function(isValid) {
      this.isSubmitDisabled = !isValid;
    }
  }
};
</script>
